import React, { Fragment } from 'react';

class Body extends React.Component 
{
    render() 
	{
        return (<div className="frame-body"> 
                 <Fragment>
                    {this.props.children}
                </Fragment>
            </div>
        );
    }
}

export default Body